import React from 'react';
import { FunctionComponent } from 'react';
import styles from './styles.module.scss';

export type DayGridCellProps = {
    startOfDay: Date;
    endOfDay: Date;
    day: string;
    dateFull: string;
    dateLong: string;
    dateMedium: string;
    dateShort: string;
    isActive: boolean;
    isSelected: boolean;
    isDisabled: boolean;
};

export const DayGridCell: FunctionComponent<DayGridCellProps> = ({
    startOfDay,
    day,
    isSelected,
    isDisabled,
}) => {
    return (
        <time
            dateTime={startOfDay.toISOString()}
            className={styles.day}
            data-selected={isSelected}
            data-disabled={isDisabled}
        >
            {day}
        </time>
    );
};
